import * as yup from 'yup';

export const sendMessageSchema = yup.object().shape({

    message: yup.string().required(),

    msisdn: yup.string().required('phone number is required')

});